(function () {
  var POPUP_SELECTOR = '[role="dialog"][aria-label="POPUP Form"] .klaviyo-form';

  function detectLanguage() {
    var htmlLang = (document.documentElement.lang || '').toLowerCase();
    var path = (window.location.pathname || '').toLowerCase();

    if (htmlLang.indexOf('fi') === 0 || path === '/fi' || path.indexOf('/fi/') === 0) {
      return 'fi';
    }

    if (htmlLang.indexOf('sv') === 0 || path === '/sv' || path.indexOf('/sv/') === 0) {
      return 'sv';
    }

    return 'en';
  }

  function getTranslations(lang) {
    var translations = {
      fi: {
        heading: 'Saat ilmoituksen, kun tuotetta on taas varastossa.',
        email: 'Sähköpostiosoite',
        button: 'ILMOITA MINULLE 🔔',
        submit: 'Lähetä',
        thanksTitle: 'Kiitos!',
        thanksBody: 'Ilmoitamme sinulle, kun tuotetta on taas saatavilla.',
        selectedProductLabel: 'Valittu tuote'
      },
      sv: {
        heading: 'Få ett meddelande när produkten finns i lager igen.',
        email: 'E-postadress',
        button: 'MEDDELA MIG 🔔',
        submit: 'Skicka',
        thanksTitle: 'Tack!',
        thanksBody: 'Vi meddelar dig när produkten finns i lager igen.',
        selectedProductLabel: 'Vald produkt'
      },
      en: {
        heading: 'Get notified when this item is back in stock.',
        email: 'Email',
        button: 'NOTIFY ME 🔔',
        submit: 'Submit',
        thanksTitle: 'Thanks!',
        thanksBody: 'We’ll let you know when this item is available again.',
        selectedProductLabel: 'Selected product'
      }
    };

    return translations[lang] || translations.en;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function setStyledText(el, text, size) {
    el.innerHTML =
      '<span style="color:#fff;font-family:inherit;font-size:' +
      size +
      'px;font-weight:500;">' +
      escapeHtml(text) +
      '</span>';
  }

  function getProductFormRoot() {
    return (
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('variant-radios form[action*="/cart/add"]') ||
      document.querySelector('variant-selects form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[id^="product-form"]')
    );
  }

  function getProductTitle() {
    var selectors = [
      'h1.product__title',
      '.product__title h1',
      '.product-single__title',
      'main h1',
      'h1'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var text = (el.textContent || '').trim();
        if (text) return text;
      }
    }

    return '';
  }

  function cleanVariantValue(value, productTitle) {
    if (!value) return '';

    var text = String(value).replace(/\s+/g, ' ').trim();
    if (!text) return '';

    if (/^default title$/i.test(text)) return '';
    if (/^sold out$/i.test(text)) return '';
    if (/^loppuunmyyty$/i.test(text)) return '';
    if (/^slutsåld$/i.test(text)) return '';
    if (/^uusimmat$/i.test(text)) return '';
    if (/^newest$/i.test(text)) return '';
    if (/^senaste$/i.test(text)) return '';
    if (/^1$/.test(text)) return '';

    if (productTitle && text.toLowerCase() === productTitle.toLowerCase()) {
      return '';
    }

    return text;
  }

  function getSelectedVariantText() {
    var root = getProductFormRoot();
    if (!root) return '';

    var productTitle = getProductTitle();
    var values = [];

    root.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
      var value = cleanVariantValue(input.value || '', productTitle);
      if (value && values.indexOf(value) === -1) {
        values.push(value);
      }
    });

    root.querySelectorAll('select').forEach(function (select) {
      var name = (select.name || '').toLowerCase();

      if (name === 'id' || name === 'quantity') return;

      var option = select.options[select.selectedIndex];
      if (!option) return;

      var rawText = (option.textContent || option.value || '').trim();
      var value = cleanVariantValue(rawText, productTitle);

      if (value && values.indexOf(value) === -1) {
        values.push(value);
      }
    });

    return values.join(' / ');
  }

  function getSelectedProductLine(label) {
    var title = getProductTitle();
    var variant = getSelectedVariantText();

    if (title && variant) return label + ': ' + title + ', ' + variant;
    if (title) return label + ': ' + title;
    return '';
  }

  function upsertSelectedProductLine(form, t) {
    var productLine = getSelectedProductLine(t.selectedProductLabel);
    var existing = form.querySelector('.custom-selected-product-line');

    if (!productLine) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      var anchor = form.querySelector('input[name="email"]') || form.querySelector('button[type="button"]');
      if (!anchor) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'custom-selected-product-line';
      wrapper.style.margin = '6px 0 16px';
      wrapper.style.textAlign = 'center';
      wrapper.style.color = '#ffffff';
      wrapper.style.fontFamily = 'inherit';
      wrapper.style.fontSize = '14px';
      wrapper.style.lineHeight = '1.4';
      wrapper.style.fontWeight = '500';

      wrapper.textContent = productLine;

      var row = anchor.closest('[data-testid="form-row"]');
      if (row && row.parentNode) {
        row.parentNode.insertBefore(wrapper, row);
      } else {
        form.appendChild(wrapper);
      }
    } else {
      existing.textContent = productLine;
    }
  }

  function translateForm(form) {
    if (!form) return;

    var lang = detectLanguage();
    var t = getTranslations(lang);

    form.querySelectorAll('[id^="rich-text-"] h1, [id^="rich-text-"] p').forEach(function (el) {
      var text = (el.textContent || '').trim();

      if (
        text === 'Get notified when this item is back in stock.' ||
        text === 'Saat ilmoituksen, kun tuotetta on taas varastossa.' ||
        text === 'Få ett meddelande när produkten finns i lager igen.'
      ) {
        setStyledText(el, t.heading, 16);
      }

      if (
        text === 'Thanks!' ||
        text === 'Kiitos!' ||
        text === 'Tack!'
      ) {
        setStyledText(el, t.thanksTitle, 26);
      }

      if (
        text === 'We’ll let you know when this item is available again.' ||
        text === "We'll let you know when this item is available again." ||
        text === 'Ilmoitamme sinulle, kun tuotetta on taas saatavilla.' ||
        text === 'Vi meddelar dig när produkten finns i lager igen.'
      ) {
        setStyledText(el, t.thanksBody, 16);
      }
    });

    var emailInput = form.querySelector('input[name="email"]');
    if (emailInput) {
      emailInput.placeholder = t.email;
      emailInput.setAttribute('aria-label', t.email);
    }

    var emailLabel = form.querySelector('label[for^="email_"]');
    if (emailLabel) {
      emailLabel.textContent = t.email;
      emailLabel.style.color = '#ffffff';
      emailLabel.style.fontFamily = 'inherit';
    }

    var button = form.querySelector('button[type="button"]');
    if (button) {
      var buttonText = (button.textContent || '').trim();

      if (
        buttonText === 'NOTIFY ME 🔔' ||
        buttonText === 'ILMOITA MINULLE 🔔' ||
        buttonText === 'MEDDELA MIG 🔔'
      ) {
        button.textContent = t.button;
      }
    }

    var submitInput = form.querySelector('input[type="submit"]');
    if (submitInput) {
      submitInput.value = t.submit;
    }

    upsertSelectedProductLine(form, t);
  }

  function scanExistingPopups() {
    document.querySelectorAll(POPUP_SELECTOR).forEach(translateForm);
  }

  var scheduled = false;

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      scanExistingPopups();
    });
  }

  function startObserver() {
    if (!document.body) return;

    var observer = new MutationObserver(function () {
      scheduleScan();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('change', function () {
      scheduleScan();
    });

    document.addEventListener('click', function () {
      scheduleScan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleScan();
      startObserver();
    });
  } else {
    scheduleScan();
    startObserver();
  }
})();
